import { useEffect, useState } from "react";

/**
 * Returns a value that only updates `delay` milliseconds after the input
 * stopped changing. Useful for debouncing search inputs that drive a query.
 */
export function useDebouncedValue<T>(value: T, delay = 250): T {
  const [debounced, setDebounced] = useState(value);

  useEffect(() => {
    const handle = window.setTimeout(() => setDebounced(value), delay);
    return () => window.clearTimeout(handle);
  }, [value, delay]);

  return debounced;
}
